// extracted by mini-css-extract-plugin
module.exports = {"security-type-form-component":"security-type-and-form_security-type-form-component__2VyAE","btn-actions":"security-type-and-form_btn-actions__2286j"};